/**
 * Tests whether a value is a finite number primitive of not.
 * NOTE: NaN and Infinity will return false.
 * @param  {any} value
 * @returns  {Boolean}
 */
const isNumber = (value) => Number.isFinite(Number(value));

export default isNumber;
